import type { PaymentOptionDetail } from '@navio/nsdk';
import { PaymentOption } from '@navio/nsdk';
import { useState } from 'react';
import { deriveStationaryPaymentChoice, resolveStationaryPaymentOption } from '../utils/stationaryCheckout';

/** Selected stationary payment method, defaulting to invoice when the profile allows it. */
export function useStationaryPaymentChoice(args: {
  isOrganization: boolean;
  paymentOptions?: PaymentOptionDetail[] | null;
  keepPayBeforeDefault?: boolean;
}) {
  const [override, setOverride] = useState<PaymentOption | null>(null);
  const choice = deriveStationaryPaymentChoice(args);
  const paymentOption = resolveStationaryPaymentOption(override, choice);

  return {
    paymentOption,
    setPaymentOption: setOverride,
    isInvoice: paymentOption === PaymentOption.INVOICE,
    showPaymentChoice: choice.invoiceSelectable && choice.payBeforeSelectable
  };
}
